// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-floating-button[data-v-38d2816a]{box-shadow:0 4px 64px rgba(0,0,0,.12)}@media(min-width:0)and (max-width:767px){.base-floating-button[data-v-38d2816a]{padding-bottom:calc(8px + env(safe-area-inset-bottom))!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
